import LegalPage from '@/pages/legal/LegalPage';

const sections = [
  { titleKey: 'legal.terms_section1_title', textKey: 'legal.terms_section1_text' },
  { titleKey: 'legal.terms_section2_title', textKey: 'legal.terms_section2_text' },
  { titleKey: 'legal.terms_section3_title', textKey: 'legal.terms_section3_text' },
  { titleKey: 'legal.terms_section4_title', textKey: 'legal.terms_section4_text' },
  { titleKey: 'legal.terms_section5_title', textKey: 'legal.terms_section5_text' },
  { titleKey: 'legal.terms_section6_title', textKey: 'legal.terms_section6_text' },
];

export default function TermsOfService() {
  return (
    <LegalPage
      titleKey="legal.terms_title"
      lastUpdatedKey="legal.terms_last_updated"
      introKey="legal.terms_intro"
      sections={sections}
      contactKey="legal.terms_contact"
      seo={{
        title: 'Terms of Service - Texio | Textile ERP Subscription Terms',
        description: 'Texio Terms of Service — subscription terms, acceptable use policy, intellectual property rights, and liability limitations for our textile ERP platform.',
        keywords: 'Texio terms of service, ERP subscription terms, textile software terms, SaaS terms',
        canonicalUrl: '/terms',
      }}
    />
  );
}